import { bajaMiembro as callBajaMiembro } from '../../../api/users/bajaMiembro';
import { logout } from '../../auth/authSlice';
import createApiModule from '../../createApiModule';
import { showSnackBar } from '../../snackBar/snackBarSlice';
import { t } from '../../../i18n';

const bajaMiembroModule = createApiModule({
  name: 'bajaMiembro',
  apiMethod: callBajaMiembro,
  onError: () => ({
    message: t(
      'StoreUsersMiembrosBajaMiembroModuleSeHaProducidoUnErrorProcesandoSuBaja',
    ),
  }),
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_ELIMINADO_PLATAFORMA'),
    }),
    logout(),
  ],
});

export const {
  start: bajaMiembro,
  success: bajaMiembroOk,
  error: bajaMiembroKo,
} = bajaMiembroModule.slice.actions;

export default bajaMiembroModule;
